import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import PATH from '@/constants/path';
import useUser from '@/hooks/use-user.hook';

const Footer = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { isSignedIn, login } = useUser();
  const navigate = useNavigate();

  return (
    <footer className="flex flex-wrap justify-between py-8 px-8 md:px-20 w-full">
      {/* Logo and brand section */}
      <div className="flex flex-col items-start gap-16 mb-8 md:mb-0">
        <div className="flex items-center gap-4">
          <img className="max-w-36 h-auto" alt="Logo" src="../../logo.svg" />
        </div>

        {/* Brand icons */}
        <div className="flex items-center gap-2">
          <img
            className="w-[45px] h-[45px]"
            alt="Vector"
            src="../../element-1.svg"
          />

          <div className="relative w-[42px] h-[42px]">
            <img className="" alt="Vector" src="../../element-2.svg" />
          </div>

          <img
            className="w-[96.46px] h-[40.87px]"
            alt="Vector"
            src="../../element-3.svg"
          />
        </div>
      </div>

      {/* Navigation links section */}
      <div className="flex min-w-[280px] flex-wrap gap-16 md:gap-24">
        {
          <nav className="flex flex-col items-start gap-3 opacity-60 cursor-pointer">
            <a
              onClick={() => {
                if (isSignedIn) {
                  navigate(PATH.DASHBOARD.INDEX);
                } else {
                  login();
                }
                window.scrollTo(0, 0);
              }}
              className="font-body-regular text-black hover:text-purple-300 transition-colors"
            >
              {t('footer.app')}
            </a>
            <a
              href={`${PATH.TERMS_OF_SERVICE}/#`}
              className="font-body-regular text-black hover:text-purple-300 transition-colors cursor-pointer"
            >
              {t('footer.terms')}
            </a>
            <a
              href={`${PATH.PRIVACY_POLICY}/#`}
              className="font-body-regular text-black hover:text-purple-300 transition-colors cursor-pointer"
            >
              {t('footer.privacy')}
            </a>
          </nav>
        }
      </div>
    </footer>
  );
};

export default Footer;
